module.exports = __webpack_public_path__ + "static/media/tree_5.5bf223bf.svg";